/**
 * Mounts the app-wide product quick view once (PR 10, plan I5) and hands
 * `open(uid, marketplace)` to everything under it (quickViewContext.ts).
 * App.tsx places it inside the query client and the router, around the tab
 * host, so the PPC pages and the ops pages share the one drawer.
 */
import { useCallback, useMemo, useState, type ReactNode } from 'react'
import { ProductQuickViewContext, quickViewScope, type ProductQuickViewApi } from './quickViewContext'
import { ProductQuickViewDrawer } from './ProductQuickViewDrawer'

export function ProductQuickViewProvider({ children }: { children: ReactNode }) {
  const [target, setTarget] = useState<{ uid: string; marketplace: string } | null>(null)
  const open = useCallback((uid: string, marketplace?: string) => {
    setTarget({ uid, marketplace: quickViewScope(marketplace) })
  }, [])
  const close = useCallback(() => setTarget(null), [])
  const api = useMemo<ProductQuickViewApi>(() => ({ open, close, available: true }), [open, close])
  return (
    <ProductQuickViewContext.Provider value={api}>
      {children}
      <ProductQuickViewDrawer uid={target?.uid ?? null} marketplace={target?.marketplace ?? 'all'} onClose={close} />
    </ProductQuickViewContext.Provider>
  )
}
